import { createPromiseAction } from "@adobe/redux-saga-promise";

export const DELETED_ITEMS_BY_TYPE_CALL_PROMISE = "DELETED_ITEMS_BY_TYPE_CALL_PROMISE";

export const FETCH_DELETED_ITEM_COUNTS_BY_MODULE = "FETCH_DELETED_ITEM_COUNTS_BY_MODULE";

export const callDeletedItemsForTypePromise = createPromiseAction(DELETED_ITEMS_BY_TYPE_CALL_PROMISE);

export function fetchDeletedItemCountsByModule() {
  return { type: FETCH_DELETED_ITEM_COUNTS_BY_MODULE };
}
